// extracted by mini-css-extract-plugin
export default {"pageContainer":"FeedPage_pageContainer__ywAZu","mainLayout":"FeedPage_mainLayout__a6N0h"};